import { HorsePowerRateBase } from './base/horse-power-rate-base';

export class HorsePowerRate extends HorsePowerRateBase { }